import React, { useState, useMemo } from 'react';
import formatDate from './formatDate';
import { ReviewStars } from './ReviewStars';
import {
  ContentReviewArea,
  ContentReviewCustomerName,
  ContentReviewDate,
  ContentReviewBody,
  ContentReviewReadMoreButton,
  ContentReviewSectionSeparator,
  ContentReviewStars,
  ReviewStarsText,
  ContentReviewBodyEllipsis,
  ContentReviewCustomerVehicle,
  ContentReviewCustomerLocation,
  ContentReviewCustomerVehicleLocationWrapper
} from './styles';
import ReviewModal from '../ReviewModal';

type OwnProps = {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  item: any;
  order?: number;
  trackEvent?: () => {};
  useEllipsis: boolean;
  useFade: boolean;
  updateUrlSearchParams?: () => {};
  updateContentReviewsSelectedReview?: () => {};
};

export default function ContentReview({
  item,
  order,
  useEllipsis = false,
  useFade = false
}: OwnProps) {
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);

  const {
    review_text: reviewText,
    review_score: reviewScore,
    review_date: reviewDate,
    vehicle: { year, make, model },
    customer: { name, location }
  } = item;

  const score = parseFloat(reviewScore);
  const date = useMemo(() => formatDate(reviewDate), [reviewDate]);

  return (
    <ContentReviewArea order={order}>
      <ContentReviewCustomerName>{name}</ContentReviewCustomerName>
      <ContentReviewDate>{date}</ContentReviewDate>
      <ContentReviewCustomerVehicleLocationWrapper>
        <ContentReviewCustomerVehicle>{`${year} ${make} ${model}`}</ContentReviewCustomerVehicle>
        <ContentReviewCustomerLocation>
          {location}
        </ContentReviewCustomerLocation>
      </ContentReviewCustomerVehicleLocationWrapper>

      <ContentReviewBody restrictHeight useFade>
        {reviewText}
      </ContentReviewBody>
      {useEllipsis && !useFade ? (
        <ContentReviewBodyEllipsis>...</ContentReviewBodyEllipsis>
      ) : null}
      <ContentReviewReadMoreButton
        data-cv-test={`Cv.Search.ContentReviews.Reviews.${order}.ReadMoreButton`}
        useFade
        onClick={() => setIsReviewModalOpen(true)}
      >
        Read More
      </ContentReviewReadMoreButton>
      <ContentReviewSectionSeparator />
      <ContentReviewStars>
        <>
          <ReviewStarsText>{`${score.toFixed(1)} OUT OF 5`}</ReviewStarsText>
          <ReviewStars score={score} />
        </>
      </ContentReviewStars>
      <ReviewModal
        isOpen={isReviewModalOpen}
        text={reviewText}
        name={name}
        onClose={() => setIsReviewModalOpen(false)}
        location={location}
        score={reviewScore}
        date={date}
        year={year}
        make={make}
        model={model}
      />
    </ContentReviewArea>
  );
}
